import manifest from '../../../assets/world-art/animations/meshy-heroes.json';
import type { GameTextureManifestEntry } from '@/game/assets/resolveGameAssetUrl';
import type { HeroAnimationFacing, HeroAnimationView } from '@/modules/game-domain/render-snapshot';

export type MeshyClip = HeroAnimationView['clip'] | 'sit' | 'cooking' | 'bandaging' | 'weapon-care';
export interface MeshyHeroClip {
  file: string; width: number; height: number; frames: number;
  frameDurationsMs: readonly number[]; loop: boolean;
  presentation: NonNullable<GameTextureManifestEntry['presentation']>;
}
interface MeshyManifest {
  campFireOffsetPx?: readonly number[];
  heroes: Record<string, { name: string; clips: Partial<Record<MeshyClip, Partial<Record<HeroAnimationFacing, MeshyHeroClip>>>> }>;
}
const catalog = manifest as MeshyManifest;
export const MESHY_CAMP_FIRE_OFFSET = [catalog.campFireOffsetPx?.[0] ?? 64, catalog.campFireOffsetPx?.[1] ?? 14] as const;
export function meshyHeroClip(variant: number, clip: MeshyClip, facing: HeroAnimationFacing): MeshyHeroClip | undefined {
  return catalog.heroes[String(variant)]?.clips[clip]?.[facing];
}
export function meshyClipDuration(clip: MeshyHeroClip): number {
  return clip.frameDurationsMs.reduce((sum, duration) => sum + duration, 0);
}
/** A normalized gait/action phase uses this particular clip's held-pose durations. */
export function meshyClipFrame(clip: MeshyHeroClip, progress: number): number {
  const elapsed = Math.max(0, Math.min(1, progress)) * meshyClipDuration(clip);
  let end = 0;
  for (let index = 0; index < clip.frames; index++) {
    end += clip.frameDurationsMs[index] ?? 0;
    if (elapsed + 1e-7 < end) return index;
  }
  return Math.max(0, clip.frames - 1);
}
